<template>
  <!-- 台账弹窗 -->
  <el-dialog width="60%" :visible.sync="dialogTableVisible" @close="qcguanbi">
    <div>
    <div class="tz_cov" >
      <img src="@/assets/image/guanbi.png" class="guanbiann" @click="qcguanbi" alt="">
      <div class="tz_cov_top">
        <span class="tz_cov_top_tit">农业废弃物治理台账</span>
      </div>
      <div class="tz_cov_left">
        <div class="tz_cov_left_tit">
          <span class="tz_cov_left_tit_text">关键指标</span>
        </div>
        <div class="tz_cov_left_bincov">
<!--          <div class="tz_cov_left_bin">-->
<!--          </div>-->
          <div id="mainEchartDiv" class="tz_cov_left_echart"></div>
        </div>

      </div>
      <div class="tz_cov_right">
        <img src="@/assets/image/kuang_zuoshang.png" class="in2con_zlf" alt="">
        <img src="@/assets/image/kuang_youshang.png" class="in2con_zys" alt="">
        <img src="@/assets/image/kuang_zuoxia.png" class="in2con_zzx" alt="">
        <img src="@/assets/image/kuang_youxia.png" class="in2con_zyx" alt="">
        <img src="@/assets/image/sanguang.png" class="tzsanguang" alt="">
        <img src="@/assets/image/sanguang.png" class="tzsanguangbt" alt="">
        <div style="overflow:hidden;line-height:2vw;">
          <div class="tz_cov_left_tit"    @click="switchFlag(true)">
            <span class="tz_cov_left_tit_text" :style="{color:(flag)?'#eddf0f':'#a39090'}">畜禽粪污治理台账</span>
          </div>
          <div class="tz_cov_left_tit"  @click="switchFlag(false)">
            <span class="tz_cov_left_tit_text" :style="{color:(!flag)?'#eddf0f':'#a39090'}">农田治理废弃物台账</span>
          </div>
          <span class="tz_cov_right_num">累计
            <span class="tz_cov_right_num_big">{{ flag?ntfmnumbtotal:qcfmnumbtotal }}</span> 条
          </span>
        </div>
        <table class="tz_cov_right_tab"  v-if="!flag">
          <thead>
            <tr class="tz_cov_right_tab_tit" style="width:100%;">
              <th class="tableheader" style="width:15%;">采样时间</th>
<!--              <th class="tableheader" style="width:18%;">监测站</th>-->
              <th class="tableheader" style="width:15%;">农作物</th>
              <th class="tableheader" style="width:15%;">农膜残留量(kg/h㎡)</th>
              <th class="tableheader" style="width:15%;">秸秆残留量(kg/h㎡)</th>
              <th class="tableheader" style="width:20%;">覆膜年份</th>
            </tr>
          </thead>
          <tbody>
            <img src="@/assets/image/noneNumber.png" class="noneNumber" alt="" v-if="ntfmnumbtotal == 0">
            <template v-else>
              <tr class="tz_cov_right_tab_list" v-for="item in ntfmnumblist" :key="item.id">
                <td>{{ item.sampTime }}</td>
<!--                <td>{{ item.stationName }}</td>-->
                <td>{{ item.cropName }}</td>
                <td>{{ item.mulchRemain }}</td>
                <td>{{ item.strawRemain }}</td>
                <td>{{ item.mulchYear }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <table class="tz_cov_right_tab"  v-if="flag">
          <thead>
          <tr class="tz_cov_right_tab_tit" style="width:100%;">
            <th class="tableheader" style="width:10%;">年份</th>
            <th class="tableheader" style="width:20%;">养殖场名称</th>
            <th class="tableheader" style="width:10%;">养殖品种</th>
            <th class="tableheader" style="width:10%;">现有存栏（只）</th>
            <th class="tableheader" style="width:10%;">固体粪便（吨）</th>
            <th class="tableheader" style="width:10%;">液体粪污（m³）</th>
            <th class="tableheader" style="width:10%;">混合粪污（m³）</th>
            <th class="tableheader" style="width:10%;">收入金额(元)</th>
          </tr>
          </thead>
          <tbody>
            <img src="@/assets/image/noneNumber.png" class="noneNumber" alt="" v-if="qcfmnumbtotal == 0">
            <template v-else>
              <tr class="tz_cov_right_tab_list" v-for="item in qcfmnumblist" :key="item.id">
                <td style="width:10%;">{{ item.countYear }}</td>
                <td style="width:20%;">{{ item.farmName }}</td>
                <td style="width:10%;">{{ item.breedVariety }}</td>
                <td style="width:10%;">{{ item.breedScale }}</td>
                <td style="width:10%;">{{ item.fecesQuantity }}</td>
                <td style="width:10%;">{{ item.urineQuantity }}</td>
                <td style="width:10%;">{{ item.mixQuantity }}</td>
                <td style="width:10%;">{{ item.chargeAmount }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </el-dialog>
</template>

<script>


import {fwlist, ntfmlist} from "@/api";

export default {
  props: {
    resourcedirect: {
      type: Array,
      default: []
    },
  },
  components: {},
  data() {
    return {
      flag: true,
      dialogTableVisible: true,
      ntfmnumbtotal: 0,
      ntfmnumblist: [],
      qcfmnumblist: [],
      qcfmnumbtotal: 0,
      resourcedirect2:[],
      resourcedirect3:[],
      echartObj: null,
    }
  },
  mounted() {
    this.fwlistcover()
  },
  methods: {
    switchFlag(v){
      this.flag = v;
      this.tzalin();
    },
    fwlistcover() {
      ntfmlist().then(res => {
        this.ntfmnumblist = res.result.records
        this.ntfmnumbtotal = res.result.total
        if(this.ntfmnumblist && this.ntfmnumblist.length > 0) {
          //mulchRemain
          let value1 = 0; //农膜残留量
          let value2 = 0; //秸秆残留量
          this.ntfmnumblist.map(item => {
            value1 += (item.mulchRemain-0);
            if(item.strawRemain){
              value2 += (item.strawRemain-0);
            }
          })
          this.resourcedirect3.push({
            name: '农膜残留量',
            value: value1
          })
          this.resourcedirect3.push({
            name: '秸秆残留量',
            value: value2
          })
        }
      });
      //粪污数据
      fwlist().then(res => {
        this.qcfmnumblist = res.result.records
        this.qcfmnumbtotal = res.result.total
        if(this.qcfmnumblist && this.qcfmnumblist.length > 0) {
          let value1 = 0; //固体
          let value2 = 0; //液体
          let value3 = 0; //混合
          this.qcfmnumblist.map(item => {
            value1 += (item.fecesQuantity-0);
            value2 += (item.urineQuantity-0);
            value3 += (item.mixQuantity-0);
          })
          this.resourcedirect2.push({
            name: '固体粪污',
            value: value1
          })
          this.resourcedirect2.push({
            name: '液体粪污',
            value: value2
          })
          this.resourcedirect2.push({
            name: '混合粪污',
            value: value3
          })
        }
        this.tzalin();
      })
    },
    tzalin() {//echart init
      let data = this.flag ? this.resourcedirect2 : this.resourcedirect3;
      console.log(data)
      this.$nextTick(() => {
        if (this.echartObj) {
          // this.echartObj.dispose();
        } else {
          this.echartObj = this.$echarts.init(document.getElementById('mainEchartDiv'));
        }
        //配置图表
        var option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            bottom: '-2%',
            left: 'center',
            itemWidth: 20,
            itemHeight: 10,
            textStyle: {
              color: '#fff'  // 图例文字颜色
            },
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: ['40%', '50%'],
              avoidLabelOverlap: false,
              emphasis: {
                label: {
                  show: false,
                  fontSize: 40,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                normal: {
                  show: true   // show设置线是否显示，默认为true，可选值：true ¦ false
                }
              },
              // 设置值域的标签
              label: {
                normal: {
                  position: 'outer',
                  formatter: '{b} : {c} '
                },
                textStyle: {
                  color: '#595959',	// 提示文字颜色
                  fontSize: 34,		// 提示文字大小
                }
              },
              data: data,
            }
          ]
        };
        this.echartObj.setOption(option);
      });
    },
    qcguanbi (){
      this.$emit('close')
    }
  }
}
</script>

<style scoped>



.tz_cov {
  width: 1110px;
  height: 600px;
  margin: 0 auto;
  /* margin-top: 4vw; */
  border: 1px solid #0169d0;
  position: relative;
  background: rgba(16, 45, 80, 0.9);
  box-shadow: inset 0px 0px 16px 0px rgba(0, 145, 255, 1);
}

.tz_cov_top {
  width: 40%;
  height: 3vw;
  margin: 0 auto;
  background: url(../assets/image/tz_tltle_bg.png) no-repeat;
  background-size: cover;
  text-align: center;
  line-height: 3vw;
  margin-bottom: 2vw;
}



.tz_cov_top_tit {
  font-size: 1vw;
  color: #fff;
  text-shadow: 0px 2px 0px rgba(4, 49, 52, 0.55);
  font-family: douyuFont;
}

.tz_cov_left {
  width: 35%;
  float: left;
}

.tz_cov_right {
  width: 65%;
  float: right;
}

.tz_cov_left_tit {
  width: 11vw;
  height: 2vw;
  text-align: left;
  padding-left: 3%;
  line-height: 2vw;
  background: url(../assets/image/tz_title2_bg.png) no-repeat;
  background-size: cover;
  margin-left: 2vw;
  float:left;
  cursor:pointer;
}

.tz_cov_left_tit_text {
  font-size: 0.9vw;
  font-weight: 500;
  color: #E5EEFA;
}

.tz_cov_left_bincov {
  position: relative;
  width: 100%;
  height: 16vw;
}

.tz_cov_left_echart {
  background: url(../assets/image/tz_binzhuangtu_bg.png) no-repeat;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 196px 210px; /* 放大到指定像素 */
  width: 100%;
  height: 13.5vw;
  position: absolute;
  z-index: 2;
  left: 18px;
  top: 66px;
}

.tz_cov_right_num {
  font-size: 0.9vw;
  float: right;
  font-weight: 500;
  color: #B3C1D1;
  margin-right: 3%;
}

.tz_cov_right_num_big {
  color: #FFF220;
  font-size: 1.5vw;
  font-family: HYChangLiSongKeBen;
}

.tz_cov_right_tab {
  width: 92%;
  height: 20vw;
  overflow: auto;
  display: block;
  margin-left: 5%;
  margin-top: 1vw;
}

/* 定义滚动条样式 */
.tz_cov_right_tab::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: rgba(240, 240, 240, 0.1);
}

/*定义滚动条轨道 内阴影+圆角*/
.tz_cov_right_tab::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, .5);
}

/*定义滑块 内阴影+圆角*/
.tz_cov_right_tab::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(87, 146, 255, .8);
  background-color: rgba(87, 146, 255, .8);
}

.tz_cov_right_tab_tit {
  width: 100%;
  height: 1.8vw;
  background: rgba(27, 63, 112, 1);
  font-size: 0.8vw;
  font-weight: 400;
  color: #5792FF;
  position: sticky;
  top: -3px; /* 固定表头位置 */
}

.tz_cov_right_tab_tit .tableheader {
  width: 20%;
  height: 1.8vw;
  border: 1px solid #285A93;
}

.tz_cov_right_tab_list {
  width: 100%;
  height: 1.8vw;
  background: rgba(80, 131, 246, 0);
  font-size: 0.8vw;
  font-weight: 400;
  color: #5792FF;
}

.tz_cov_right_tab_list td {
  height: 1.8vw;
  text-align: center;
  border: 1px solid #285A93;
  color: #fff;
}

.noneNumber {
  width: 30%;
  margin: 0 auto;
  display: block;
  margin-top: 60px;
}

</style>